import * as THREE from 'three'

export const TINT_EMISSIVE_INTENSITY = 0.25

const authoredColor = new WeakMap<THREE.MeshStandardMaterial, THREE.Color>()

export function setMaterialTint(material: THREE.MeshStandardMaterial, tint: number | null) {
  let authored = authoredColor.get(material)
  if (!authored) {
    authored = material.color.clone()
    authoredColor.set(material, authored)
  }
  if (tint === null) {
    material.color.copy(authored)
    material.emissive.setHex(0x000000)
    material.emissiveIntensity = 0
    return
  }
  material.color.setHex(tint)
  material.emissive.setHex(tint)
  material.emissiveIntensity = TINT_EMISSIVE_INTENSITY
}
